import { Fragment, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import Navigation from 'components/Navigation';
import PageContent from 'components/PageContent';
import Footer from 'components/Footer';
import { FlightTicketProposalStatusEnum } from 'utils/constants.ts';
import ConfirmedFlightOfferPage from 'pages/ConfirmedFlightOffer';

import { useFlightTicketProposal } from 'entities/Flights/sdk';
import PaymentView from './PaymentView';
import DetailsView from './DetailsView';
import { FlightOfferViewEnum } from './constants';
import { NoFlightOffer } from './NoFlightOfferView';

const FlightOffer = () => {
  const params = useParams<{ offerId: string }>();

  const [view, setView] = useState<FlightOfferViewEnum>(FlightOfferViewEnum.DETAILS);

  const viewRef = useRef(view);

  useEffect(() => {
    viewRef.current = view;
  }, [view]);

  const {
    data: flightTicketProposal,
    isLoading: isFlightTicketProposalLoading,
    mutate,
  } = useFlightTicketProposal(params.offerId ?? '');

  const [currency, setCurrency] = useState<string | null>(null);

  const initialized = useRef(false);

  const isShowNoOfferPage =
    flightTicketProposal?.status === FlightTicketProposalStatusEnum.NEW ||
    flightTicketProposal?.status === FlightTicketProposalStatusEnum.EXPIRED ||
    flightTicketProposal?.status === FlightTicketProposalStatusEnum.DECLINED;

  useEffect(() => {
    if (flightTicketProposal && !initialized.current) {
      setCurrency(flightTicketProposal.default_currency);
      initialized.current = true;
    }
  }, [flightTicketProposal]);

  const isConfirmedFlightOfferPage = flightTicketProposal
    ? [
        FlightTicketProposalStatusEnum.CONFIRMED_AND_PAID,
        FlightTicketProposalStatusEnum.TICKETS_SENT,
        FlightTicketProposalStatusEnum.OPERATED,
      ].includes(flightTicketProposal?.status)
    : false;

  return (
    <Fragment>
      <Navigation />
      {isFlightTicketProposalLoading ? (
        <PageContent>Loading...</PageContent>
      ) : flightTicketProposal ? (
        <Fragment>
          {isShowNoOfferPage ? (
            <NoFlightOffer show={isShowNoOfferPage} />
          ) : (
            <Fragment>
              {isConfirmedFlightOfferPage ? (
                <ConfirmedFlightOfferPage
                  flightTicketProposal={flightTicketProposal}
                  currency={currency}
                  setCurrency={setCurrency}
                  flightTicketProposalMutate={mutate}
                />
              ) : (
                <Fragment>
                  {view === FlightOfferViewEnum.DETAILS && (
                    <DetailsView
                      flightTicketProposal={flightTicketProposal}
                      setView={setView}
                      currency={currency}
                      setCurrency={setCurrency}
                      flightTicketProposalMutate={mutate}
                    />
                  )}
                  {view === FlightOfferViewEnum.PAYMENT && (
                    <PaymentView
                      flightTicketProposal={flightTicketProposal}
                      viewRef={viewRef}
                      setView={setView}
                      currency={currency}
                      setCurrency={setCurrency}
                      flightTicketProposalMutate={mutate}
                    />
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      ) : (
        <PageContent>No offer found</PageContent>
      )}
      <Footer />
    </Fragment>
  );
};

export default FlightOffer;
